import styled from 'styled-components';
import type { ExtendedTheme } from '@theme/theme';

export const NavListWrapper = styled.ul`
  display: ${(props: { opened: boolean }) => (props.opened ? 'block' : 'none')};
  margin: 0;
  padding: 0;
  text-decoration: none;

  .active-parent {
    a {
      color: ${({ theme }: { theme: ExtendedTheme }) => theme.palette.text.primary};
    }
    &:has(.prevent-redirect) {
      font-weight: 700;
      background: none;
      cursor: default;
    }
  }
`;

export const NavItemWrapper = styled.li`
  font-size: ${({ theme }: { theme: ExtendedTheme }) => theme.typography.fontSize}px;
  display: block;

  &.divider {
    border-bottom: 1px solid ${({ theme }: { theme: ExtendedTheme }) => theme.palette.divider};
    margin-bottom: ${({ theme }: { theme: ExtendedTheme }) => theme.shape.verticalIntend}px;
    padding-bottom: ${({ theme }: { theme: ExtendedTheme }) => theme.shape.verticalIntend}px;
  }

  li {
    margin-left: 10px;
  }

  p {
    ${({ theme }: { theme: ExtendedTheme }) => theme.breakpoints.down('lg')} {
      padding-left: 40px;
      margin-right: 10px;
    }
  }

  ul {
    span {
      left: 22px;
    }

    a {
      margin-left: 10px;
    }

    ul {
      span {
        left: 32px;
      }

      a {
        margin-left: 20px;
      }
    }
  }
`;
